import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../../../styles/theme/foundation/colors';

const ModalOptionBlock = ({ imgSrc, title, description, onClick, cypressId }) => (
  <Box
    _hover={{ cursor: 'pointer', boxShadow: 'accent' }}
    data-cy={cypressId}
    height="300px"
    layerStyle="bgCard"
    p={6}
    textAlign="center"
    width="284px"
    onClick={onClick}
  >
    <Box
      backgroundImage={imgSrc}
      backgroundPosition="center"
      backgroundRepeat="no-repeat"
      backgroundSize="cover"
      height="155px"
      margin="0 auto"
      width="190px"
    />
    <Text color={colors.greyScale['900']} pb={2} pt={1} textStyle="bodyXl500">{title}</Text>
    <Text>{description}</Text>
  </Box>
);

ModalOptionBlock.propTypes = {
  imgSrc: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  onClick: PropTypes.func,
  cypressId: PropTypes.string
};

export default ModalOptionBlock;
